//import images
import accessories from './accessories.jpg';
import audio from './audio.jpg';
import connected from './connected.jpg';
import down_arrow from './down-arrow.svg';
import favicon from './favicon.ico';
import game from './game.jpg';
import logo from './logo.svg';
import model_3 from './model-3.jpg';
import model_s from './model-s.jpg';
import model_x from './model-x.jpg';
import model_y from './model-y.jpg';
import new_interior from './new-interior.jpg';
import solar_panel from './solar-panel.jpg';
import solar_roof from './solar-roof.jpg';

export const images = {
    accessories,
    audio,
    connected,
    down_arrow,
    favicon,
    game,
    logo,
    model_3,
    model_s,
    model_x,
    model_y,
    new_interior,
    solar_panel,
    solar_roof,
};
